
import api from "./api";
import { AxiosInstance } from "axios";
import mockApi from "./mockApi";
import { API_CONFIG } from "../config/apiConfig";
import { BroadcastEmailRequest, BroadcastEmailResponse } from "../types/api";

const USE_MOCK_API =
  process.env.REACT_APP_USE_MOCK === "true" && API_CONFIG.IS_DEVELOPMENT;
const apiClient = USE_MOCK_API ? (mockApi as any) : (api as AxiosInstance); // TODO fix mockApi type

const broadcastService = {
  getDrafts: async (): Promise<BroadcastEmailResponse[]> => {
    try {
      const response = await api.get(`/api/BroadcastEmail/draft`);
      return response.data;
    } catch (error) {
      console.error("Error fetching drafts:", error);
      throw error;
    }
  },

  getTemplates: async (): Promise<BroadcastEmailResponse[]> => {
    try {
      const response = await api.get("/api/BroadcastEmail/templates");
      return response.data;
    } catch (error) {
      console.error("Error fetching templates:", error);
      throw error;
    }
  },

  getSentEmails: async (): Promise<BroadcastEmailResponse[]> => {
    try {
      const response = await api.get("/api/BroadcastEmail/sent_emails");
      return response.data;
    } catch (error) {
      console.error("Error fetching sent emails:", error);
      throw error;
    }
  },

  saveDraft: async (
    emailData: BroadcastEmailRequest
  ): Promise<BroadcastEmailResponse> => {
    try {
      const response = await apiClient.post(
        "/api/BroadcastEmail/save_draft",
        emailData
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data || error.message;
    }
  },
  saveTemplates: async (
    emailData: BroadcastEmailRequest
  ): Promise<BroadcastEmailResponse> => {
    try {
      const response = await apiClient.post(
        "/api/BroadcastEmail/template",
        emailData
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data || error.message;
    }
  },

  deleteDraft: async (draftId: number): Promise<void> => {
    try {
      await api.delete(`/api/BroadcastEmail/draft/${draftId}`);
    } catch (error) {
      console.error("Error deleting draft:", error);
      throw error;
    }
  },

  deleteTemplate: async (templateId: number): Promise<void> => {
    try {
      await api.delete(`/api/BroadcastEmail/delete_template/${templateId}`);
    } catch (error) {
      console.error("Error deleting template:", error);
      throw error;
    }
  },
  sendEmail: async (emailData: BroadcastEmailRequest): Promise<void> => {
    try {
      await api.post("/api/BroadcastEmail/send_email", emailData);
    } catch (error) {
      console.error("Error sending email:", error);
      throw error;
    }
  },
  getEmailById: async (id: number): Promise<BroadcastEmailResponse> => {
    try {
      const response = await api.get(`/api/BroadcastEmail/email/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching email:", error);
      throw error;
    }
  },
};

export default broadcastService;
